import '../vendor/jquery.sketch'

let reportFormSketch = {
    $modalSketch: $('#js-modalSketch'),
    $sketch: $('#js-sketch'),
    $sketchImage: $('#js-sketchImage'),
    $sketchInput: $('#js-sketchInput'),
    $sketchRemove: $('#js-sketchRemove'),
    $sketchView: $('#js-sketchView'),
    messageConfirmRemove: $('#js-sketchMessageConfirmRemove').text(),

    init() {
        this.$sketch.sketch()
        this.$sketch.on('sketch:save', this.onSave.bind(this))
        this.$sketchRemove.on('click', this.onRemove.bind(this))
    },

    onRemove(e) {
        e.preventDefault()

        if (confirm(this.messageConfirmRemove)) {
            this.$sketch.sketch('clear')
            this.$sketchImage.attr('src', '')
            this.$sketchInput.val('')
            this.$sketchView.removeClass('is-visible')
        }
    },

    onSave(e, data) {
        this.$sketchInput.val(data)
        this.$sketchImage.attr('src', data)
        this.$sketchView.addClass('is-visible')
        this.$modalSketch.modal('close')
    }
}

export default reportFormSketch